import isNull from 'lodash/isNull';
import merge from 'lodash/merge';
import isUndefined from 'lodash/isUndefined';
import defaultGlobalConfig from '../../config/globalConfig';

const optimizelyConfig = require('../../shared/optimizely-config');
/* eslint-disable */
const experimentFeatureFlagsDefaultState = Object.keys(optimizelyConfig.experiments).reduce((allToFalse, featureKey) => {
  return {
    ...allToFalse,
    [`${featureKey}`]: false,
  };
}, {});
const rolloutFeatureFlagsDefaultState = optimizelyConfig.rollouts.reduce((allToFalse, featureKey) => {
  return {
    ...allToFalse,
    [`${featureKey}`]: false,
  };
}, {});
/* eslint-enable */

const getters = {
  featureFlag: state => (featureFlag, options) => {
    if (window.$optimizely && window.$optimizely.getClient() && !state.sessionFallbackFlags.includes(featureFlag)) {
      window.$optimizely.impression(featureFlag, options);
    }
    const flagValue = state.featureFlags[featureFlag];
    return (isNull(flagValue) || isUndefined(flagValue)) ? null : flagValue;
  },
  featureFlags: state => state.featureFlags,
  flagWithDefault: state => (featureFlag, defaultValue) => {
    const { featureFlags } = state;
    const optInitialized = window.$optimizely && window.$optimizely.isInitialized();
    const flagValue = optInitialized ? (featureFlags && featureFlags[featureFlag]) : defaultValue;
    return flagValue;
  },
  featureFlagsLastUpdated: state => state.lastUpdated,
  manualDatafileJson: state => state.manualDatafileJson,
  manualDisableOptimizely: state => state.manualDisableOptimizely,
  optimizelyDebugMode: state => state.optimizelyDebugMode,
  globalConfig: state => state.globalConfig,
  sessionFallbackFlags: state => state.sessionFallbackFlags,
};

const mutations = {
  updateFeatures: (state, updatedFeatureFlags) => {
    state.featureFlags = updatedFeatureFlags;
  },
  updateConfig: (state, updatedGlobalConfig) => {
    state.globalConfig = merge(state.globalConfig, updatedGlobalConfig);
  },
  setLastUpdated: (state) => {
    state.lastUpdated = Date.now();
  },
  setManualDatafileJson: (state, DatafileJson) => {
    state.manualDatafileJson = DatafileJson;
  },
  disableOptimizely: (state, bool) => {
    state.manualDisableOptimizely = bool;
  },
  toggleOptimizelyDebugMode: (state, bool) => {
    state.optimizelyDebugMode = bool;
  },
  setSessionFallbackFlags: (state, flagName) => {
    if (!state.sessionFallbackFlags.includes(flagName)) {
      state.sessionFallbackFlags = state.sessionFallbackFlags.concat([flagName]);
    }
  },
};

// DO NOT CHANGE FEATURE FLAGS UNLESS YOU'RE AWARE OF THE PROCESS
// https://www.notion.so/luminarymedia/Dev-Process-for-Feature-Flags-a9d35d529f6d4b79adf9c7daaf142538

const state = {
  featureFlags: {
    ...experimentFeatureFlagsDefaultState,
    ...rolloutFeatureFlagsDefaultState,
  },
  lastUpdated: null,
  manualDatafileJson: null,
  manualDisableOptimizely: false,
  optimizelyDebugMode: false,
  globalConfig: defaultGlobalConfig,
  sessionFallbackFlags: [],
};

const actions = {
  updateFeatureFlags: (context, updatedFeatureFlags) => {
    context.commit('updateFeatures', updatedFeatureFlags);
    context.commit('setLastUpdated');
  },
  updateGlobalConfig: (context, updatedGlobalConfig) => {
    context.commit('updateConfig', updatedGlobalConfig);
  },
  // THESE ACTIONS ARE FOR DEV-PANEL PURPOSE ONLY
  setManualDatafile: (context, dataFileUrl) => {
    context.commit('setManualDatafileJson', dataFileUrl);
  },
  disableOptimizely: (context, bool) => {
    context.commit('disableOptimizely', bool);
  },
  toggleOptimizelyDebug: (context, bool) => {
    context.commit('toggleOptimizelyDebugMode', bool);
  },
  addFallbackFlag: (context, flagName) => {
    context.commit('setSessionFallbackFlags', flagName);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
